<script>
    import { Bar } from 'vue-chartjs'
    import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips'

    export default {
        extends: Bar,
        props:['items'],
        mounted () {
            this.rerender()
        },
        methods: {
            rerender() {
                let labels = [],
                    archive_count = [],
                    final_count = [],
                    progress_count = []
                ;
                this.items.forEach((item) => {
                    labels.push(item.user);
                    archive_count.push(item.archive_count)
                    final_count.push(item.final_count)
                    progress_count.push(item.progress_count)
                });

                // Overwriting base render method with actual data.
                this.renderChart(
                    {
                        labels: labels,
                        datasets: [
                            {
                                label: 'Завершили диагностику',
                                backgroundColor: '#4dbd74',
                                data: final_count
                            },
                            {
                                label: 'Архив',
                                backgroundColor: '#f5302e',
                                data: archive_count
                            },
                            {
                                label: 'В процессе диагностики',
                                backgroundColor: '#2eadd3',
                                data: progress_count
                            }
                        ]
                    },
                    {
                        responsive: true,
                        maintainAspectRatio: false,
                        scales: {
                            yAxes: [{
                                ticks: {
                                    beginAtZero: true
                                }
                            }]
                        },
                        tooltips: {
                            enabled: false,
                            custom: CustomTooltips,
                            intersect: true,
                            mode: 'index',
                            position: 'nearest',
                            callbacks: {
                                labelColor: function (tooltipItem, chart) {
                                    return { backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].backgroundColor }
                                }
                            }
                        }
                    }
                )
            }
        },
        watch: {
            items: function() {
                this.rerender();
            }
        }
    }
</script>
